var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.98 23.96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 10.9L2.46.41a1.44 1.44 0 00-2 0 1.55 1.55 0 000 2.12l9.07 9.45-9.11 9.45a1.55 1.55 0 000 2.12 1.44 1.44 0 002 0l10.16-10.57a1.56 1.56 0 000-2.08z",
    fill: "currentColor"
  })));
};

export default SvgChevron;